import React from 'react';
import Header from './Header';
import background from './img/softwarePartners.png';
import MobileNavigation from './MobileNavigation';
import Footer from './Footer';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

const StyledTabs = styled((props) => (
  <Tabs
    {...props}
    TabIndicatorProps={{
      children: <span className="MuiTabs-indicatorSpan" />
    }}
    variant="scrollable"
    scrollButtons
    allowScrollButtonsMobile
    centered
  />
))(({ theme }) => ({
  '& .MuiTabs-indicator': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent'
  },
  '& .MuiTabs-indicatorSpan': {
    width: '100%',
    backgroundColor: '#1C7BC0'
  }
}));

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.pxToRem(15),
  marginRight: theme.spacing(1),
  color: '#000000',
  '&.Mui-selected': {
    color: '#000000',
    fontWeight: theme.typography.fontWeightMedium
  },
  '&.Mui-focusVisible': {
    backgroundColor: 'rgba(100, 95, 228, 0.32)'
  }
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="span">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

function TabProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}

const DeveloperTestData = () => {
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <MobileNavigation />
      <section className="bg-[#212121]">
        <div
          className="w-full pb-28"
          style={{
            backgroundImage: `url(${background})`,
            backgroundSize: '200% 200%',
            backgroundPosition: 'bottom center',
            backgroundRepeat: 'no-repeat'
          }}
        >
          <Header />
          <div className="p-4 row md:p-8 how">
            <h3 className="text-white large">Test Data</h3>
          </div>
          <div className="flex p-16 row flex-col justify-center flex-start gap-6 self-stretch rounded-[28px] bg-white !mb-10">
            <Box sx={{ width: '100%' }}>
              <Box
                display="flex"
                width="100%"
                sx={{ borderBottom: 1, borderColor: 'divider', justifyContent: 'center' }}
              >
                <StyledTabs value={value} onChange={handleChange} aria-label="training video tabs">
                  <StyledTab label="Test Cards" {...TabProps(0)} />
                  <StyledTab label="Card Number Triggers" {...TabProps(1)} />
                </StyledTabs>
              </Box>

              <TabPanel value={value} index={0}>
                <h2 className="text-black large">Test Cards:</h2>
                <p className="text-black light">
                  Tip: The following test cards can be used in the sandbox environment for testing.
                  Any valid expiration date will be accepted.
                </p>
                <table className="tg" style={{ undefined, tableLayout: 'fixed', width: '100%' }}>
                  <colgroup>
                    <col style={{ width: '50%' }} />
                    <col style={{ width: '50%' }} />
                  </colgroup>
                  <thead>
                    <tr>
                      <th className="font-bold text-center text-black">Card Number</th>
                      <th className="font-bold text-center text-black">Card Brand</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>4111111111111111</td>
                      <td>
                        Visa - <b>Debit</b>
                      </td>
                    </tr>
                    <tr>
                      <td>4005519200000004</td>
                      <td>Visa</td>
                    </tr>
                    <tr>
                      <td>4009348888881881</td>
                      <td>Visa</td>
                    </tr>
                    <tr>
                      <td>4012000033330026</td>
                      <td>Visa</td>
                    </tr>
                    <tr>
                      <td>4012000077777777</td>
                      <td>Visa</td>
                    </tr>
                    <tr>
                      <td>4217651111111119</td>
                      <td>
                        Visa - <b>Debit</b>
                      </td>
                    </tr>
                    <tr>
                      <td>4264281500006662</td>
                      <td>Visa</td>
                    </tr>
                    <tr>
                      <td>4264281555555555</td>
                      <td>Visa</td>
                    </tr>
                    <tr>
                      <td>4500600000000061</td>
                      <td>Visa</td>
                    </tr>
                    <tr>
                      <td>5555555555554444</td>
                      <td>
                        Mastercard - <b>Debit</b>
                      </td>
                    </tr>
                    <tr>
                      <td>2223000048400011</td>
                      <td>Mastercard</td>
                    </tr>
                    <tr>
                      <td>5424180000000007</td>
                      <td>Mastercard</td>
                    </tr>
                    <tr>
                      <td>5424180055555558</td>
                      <td>Mastercard</td>
                    </tr>
                    <tr>
                      <td>378282246310005</td>
                      <td>American Express</td>
                    </tr>
                    <tr>
                      <td>379605175555555</td>
                      <td>American Express</td>
                    </tr>
                    <tr>
                      <td>6011111111111117</td>
                      <td>Discover</td>
                    </tr>
                    <tr>
                      <td>6011361000006668</td>
                      <td>Discover</td>
                    </tr>
                    <tr>
                      <td>36259600000004</td>
                      <td>Diners</td>
                    </tr>
                    <tr>
                      <td>3530111333300000</td>
                      <td>JCB</td>
                    </tr>
                  </tbody>
                </table>
                <h2 className="mt-3 text-black large">ACH:</h2>
                <table className="tg" style={{ undefined, tableLayout: 'fixed', width: '100%' }}>
                  <colgroup>
                    <col style={{ width: '50%' }} />
                    <col style={{ width: '50%' }} />
                  </colgroup>
                  <thead>
                    <tr>
                      <th className="font-bold text-center text-black">Account Number</th>
                      <th className="font-bold text-center text-black">Routing Number</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>123456789</td>
                      <td>490000018</td>
                    </tr>
                  </tbody>
                </table>
              </TabPanel>
              <TabPanel value={value} index={1}>
                <h2 className="text-black large">Card Number Triggers:</h2>
                <p className="text-black light">
                  Tip: Use a $1.00 amount with the following card numbers unless a different amount is listed.
                </p>
                <table className="tg" style={{ undefined, tableLayout: 'fixed', width: '100%' }}>
                  <colgroup>
                    <col style={{ width: '50%' }} />
                    <col style={{ width: '50%' }} />
                  </colgroup>
                  <thead>
                    <tr>
                      <th className="font-bold text-center text-black">Card Number</th>
                      <th className="font-bold text-center text-black">Response</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>4124939999999990</td>
                      <td>Insufficient Funds</td>
                    </tr>
                    <tr>
                      <td>5424180000005550</td>
                      <td>Decline</td>
                    </tr>
                    <tr>
                      <td>379605177111118</td>
                      <td>Decline</td>
                    </tr>
                    <tr>
                      <td>6011208702222228</td>
                      <td>Decline at $1.00, approved at $2,720.07</td>
                    </tr>
                  </tbody>
                </table>
              </TabPanel>
            </Box>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default DeveloperTestData;
